import React from 'react'
import { ErrorBoundary as RollbarErrorBoundary } from '@rollbar/react'

// One unrenderable value should cost its own field, not the whole page. Without a boundary
// this close to the value, a single throw reaches the app-root boundary and a buyer gets the
// "Whoops, something went wrong." card instead of the quote they were sent. The error still
// reaches Rollbar through this boundary, so degrading here hides nothing. (GEA-9055)
const fallbackUI = () => <span className="italic text-gray-500">(unavailable)</span>

const FieldErrorBoundary = ({ children }: { children?: React.ReactNode }) => (
  <RollbarErrorBoundary fallbackUI={fallbackUI}>{children}</RollbarErrorBoundary>
)

export default FieldErrorBoundary
